import { render, staticRenderFns } from "./RecordHint.vue?vue&type=template&id=535efcea&"
import script from "./RecordHint.vue?vue&type=script&lang=js&"
export * from "./RecordHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535efcea')) {
      api.createRecord('535efcea', component.options)
    } else {
      api.reload('535efcea', component.options)
    }
    module.hot.accept("./RecordHint.vue?vue&type=template&id=535efcea&", function () {
      api.rerender('535efcea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/RecordHint.vue"
export default component.exports